import store from "@/store/index";
import router from "@/router/index";

export function GetMatchMetaData(page_meta_title) {
  const meta_data_list = store.state.page_meta;
  const current_meta_data = meta_data_list.find((item) => {
    return item.PageTitle == page_meta_title;
  });
  if (current_meta_data) {
    return {
      title: current_meta_data.Title,
      content: current_meta_data.Content,
      image: store.getters.getImageUrl(current_meta_data.Image),
    };
  } else {
    return false;
  }
}

export function GetBaseMetaData() {
  const meta_data_list = store.state.page_meta;
  return {
    title: meta_data_list[0].Title,
    content: meta_data_list[0].Content,
    image: store.getters.getImageUrl(meta_data_list[0].Image),
  };
}

export function GetMetaData(
  page_meta_title = "",
  { title, content = "", image = "" }
) {
  let meta_data = GetMatchMetaData(page_meta_title);
  const base_meta_data = GetBaseMetaData();
  meta_data == false ? (meta_data = base_meta_data) : "";
  title != "" ? (meta_data.title = title) : "";
  content != "" ? (meta_data.content = content) : "";
  image != "" ? (meta_data.image = image) : "";
  meta_data.content.length > 155
    ? (meta_data.content = meta_data.content.slice(0, 155) + "...")
    : "";
  meta_data.image == "" ? (meta_data.image = base_meta_data.image) : "";
  return {
    title: meta_data.title + base_meta_data.title,
    meta: [
      {
        property: "og:url",
        name: "og:url",
        content: process.env.VUE_APP_BASEURL + router.history.current.fullPath,
        vmid: "og:url",
      },
      {
        property: "og:title",
        name: "og:title",
        content: meta_data.title + base_meta_data.title,
        vmid: "og:title",
      },
      {
        property: "og:description",
        name: "og:description",
        content: meta_data.content,
        vmid: "og:description",
      },
      {
        property: "twitter:description",
        name: "twitter:description",
        content: meta_data.content,
        vmid: "twitter:description",
      },
      {
        property: "description",
        name: "description",
        content: meta_data.content,
        vmid: "description",
      },
      {
        property: "og:image",
        name: "og:image",
        content: meta_data.image,
        vmid: "og:image",
      },
      {
        property: "apple-mobile-web-app-title",
        name: "apple-mobile-web-app-title",
        content: meta_data.title + base_meta_data.title,
        vmid: "apple-mobile-web-app-title",
      },
      {
        property: "application-name",
        name: "application-name",
        content: meta_data.title + base_meta_data.title,
        vmid: "application-name",
      },
      {
        property: "og:site_name",
        name: "og:site_name",
        content: "官方網站" + base_meta_data.title,
        vmid: "og:site_name",
      },
      {
        property: "og:type",
        name: "og:type",
        content: "website",
        vmid: "og:type",
      },
      {
        property: "og:locale",
        name: "og:locale",
        content: "zh_tw",
        vmid: "og:locale",
      },
    ],
  };
}
